import i18next from 'i18next'
import memoize from 'lodash/memoize'

/**
 * Min Max for discount percentage
 */
export const discountMinMax = (minValue: number, maxValue?: number) => (value: string) => {
  const parsedValue = Number.parseFloat(value)

  if (parsedValue >= minValue && (maxValue === undefined || parsedValue <= maxValue)) {
    return undefined // no error
  }

  return maxValue === undefined
    ? i18next.t('global.value_out_of_bounds_min', { value: minValue })
    : i18next.t('global.value_out_of_bounds_min_max', { minValue, maxValue })
}

export const discountMinMaxCheck = memoize(discountMinMax, (min, max) => `${min}, ${max}`)
